import { createContext } from 'react';
import * as utils from "../utils/utils.js";

export const AuthContext = createContext(null);

// Return user or null
export function useAuth() {

    if (utils.getWithExpiry('motus_access_token') != null) {
        return({id:utils.getWithExpiry('motus_user_id'), token: utils.getWithExpiry('motus_access_token')});
    }
    else {
        //auto logout
        utils.forceLogout();
        return null;
    }
}